import React, { useState } from 'react';
import { tutorAuthService } from '../services/tutorAuth';
import './ComplementCadastroModal.css';

interface ComplementCadastroModalProps {
  onComplete: () => void;
}

const ComplementCadastroModal: React.FC<ComplementCadastroModalProps> = ({ onComplete }) => {
  const [telefone, setTelefone] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [showWelcome, setShowWelcome] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const numero = telefone.replace(/\D/g, '');
    if (numero.length < 10) {
      setError('Informe um número válido com DDD (ex.: 81 99999-9999).');
      return;
    }
    setError('');
    setSubmitting(true);
    try {
      await tutorAuthService.updateTutor({ telefone: telefone.trim() });
      setShowWelcome(true);
    } catch (err: any) {
      setError(err.response?.data?.detail || 'Não foi possível salvar. Tente de novo.');
    } finally {
      setSubmitting(false);
    }
  };

  if (showWelcome) {
    return (
      <div className="complement-cadastro-overlay" role="dialog" aria-modal="true" aria-labelledby="complement-welcome-title">
        <div className="complement-welcome-modal">
          <div className="complement-welcome-icon">✓</div>
          <h2 id="complement-welcome-title">Número salvo!</h2>
          <p className="complement-welcome-text">Bem-vindo ao PETCLUB.</p>
          <button
            type="button"
            className="btn btn-primary complement-cadastro-btn"
            onClick={onComplete}
          >
            Continuar
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="complement-cadastro-overlay" role="dialog" aria-modal="true" aria-labelledby="complement-cadastro-title">
      <div className="complement-cadastro-modal">
        <div className="complement-cadastro-icon">🐾</div>
        <h2 id="complement-cadastro-title">Complete seu cadastro</h2>
        <p className="complement-cadastro-text">
          Para cuidar do seu pet da melhor forma, precisamos do seu número de telefone.
          Assim podemos entrar em contato em caso de necessidade, confirmações de agendamento ou novidades do PETCLUB.
        </p>
        <form onSubmit={handleSubmit} className="complement-cadastro-form">
          <label htmlFor="complement-telefone">Telefone (com DDD) *</label>
          <input
            id="complement-telefone"
            type="tel"
            value={telefone}
            onChange={(e) => setTelefone(e.target.value)}
            placeholder="Ex.: (81) 99999-9999"
            autoComplete="tel"
            required
            disabled={submitting}
            className="complement-cadastro-input"
          />
          {error && <p className="complement-cadastro-error">{error}</p>}
          <button type="submit" className="btn btn-primary complement-cadastro-btn" disabled={submitting}>
            {submitting ? 'Salvando...' : 'Salvar e continuar'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ComplementCadastroModal;
